import { useEffect, useState } from 'react';
import ADD_USER_FLOW from '../graphql/ADD_USER_FLOW';
import ADD_USER_EMAIL from '../graphql/ADD_USER_EMAIL';
import INSERT_COMMON_INFO from '../graphql/INSERT_COMMON_INFO';
import { useMutation } from '@apollo/client';
import firePixelBlueKeel from '../pixels/bluekeelPixel';
import { setCookie, checkCookie } from '../utils/helpers';

const useClickSubmit = (isOptOut, tracking, shouldExecute) => {
    const [ isDuplicate ] = useState(checkCookie('em_sub'));

	const { 
        HSID, PID, OID, EID, SID, UID,
        VERTICAL, TYPE, EMAIL,
        ip, fname, lname, address, city, state, zip
    } = tracking;

    const [ addUserFlow ] = useMutation(ADD_USER_FLOW, { 
        onCompleted: () => console.log('UserFlow posted to Mongo.') 
    });

    const [ insertCommonInfo ] = useMutation(INSERT_COMMON_INFO, { 
        onCompleted: () => console.log('CommonInfo posted to CF.') 
    });

    const [ addUserEmail ] = useMutation(ADD_USER_EMAIL, { 
        onCompleted: (data) => {
            const submittedEmail = data.addUserEmail.body.email
            console.log('Email posted to Mongo:', submittedEmail)
            if(submittedEmail && submittedEmail !== '') {
                console.log('Setting submission cookie!');
                setCookie('em_sub', submittedEmail, 30);
            };
        }
    });

    const postToCommonInfo = emailProp => {
        insertCommonInfo({
            variables: {
                visitor: {
                    'hsid': Number(HSID),
                    'oid': Number(OID),
                    'eid': EID,
                    'uid': UID,
                    'sid': Number(SID),
                    'email': emailProp,
                    'ip_address': ip, 
                    fname, lname, address, city, state, zip
                }
            }
        });
    };

    const postEmailToMongo = emailProp => {
        if(emailProp && emailProp !== '' && emailProp !== 'omit' && !isOptOut) {
            addUserEmail({
                variables: {
                    clickId: Number(HSID),
                    email: emailProp
                }
            })
        }
    };

    const postFlowToMongo = () => {
        addUserFlow({
            variables: {
                clickId: Number(HSID),
                flow: {
                    'pid': Number(PID),
                    'vertical': VERTICAL, 
                    'loan_type': TYPE,
                    'debt_type': 'N/A', 
                    'debt_amount': 'N/A'
                }
            }
        })
    };

	useEffect(() => {
        if(shouldExecute) {
            const insertEmail = (isOptOut || isDuplicate || EMAIL === 'omit') ? '' : EMAIL;
            firePixelBlueKeel(HSID);
            postToCommonInfo(insertEmail);
            postEmailToMongo(insertEmail);
            postFlowToMongo();
        };

		// eslint-disable-next-line
	}, [shouldExecute]);

	return;
};

export default useClickSubmit;